import { Payment } from '../payment/payment.model';
import { PaymentService } from './payment.service';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';
import { HttpResponse } from '@angular/common/http';

@Injectable()
export class PaymentTypeaheadService {

    // in milliseconds
    readonly DEBOUNCE_TIME = 300;

    constructor(private paymentService: PaymentService) {
    }

    resultFormatter = (payment: any) => this.asString(payment);

    inputFormatter = (payment: any) => this.asString(payment);

    search = (text$: Observable<String>) =>
        text$
            .debounceTime(this.DEBOUNCE_TIME)
            .distinctUntilChanged()
            .switchMap(term => this.paymentService
                .search({ query: term })
                .switchMap((res: HttpResponse<Payment[]>) => Observable.of(res.body))
            )

    asString(payment: Object): String {
        return payment !== null ? payment['id'] + ': ' + payment['type'] + ' - '
            + payment['payer']['user']['firstName'] + ' '
            + payment['payer']['user']['lastName'] : ' ';
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment/payment.typeahead.service.ts